export const content = {
	en: {
		select_company: "Select company",
		select: "Select",
	},
	de: { select_company: "Unternehmen auswählen", select: "Auswählen" },
};
